module.exports = __webpack_public_path__ + "static/media/signage-indoor-img24.91307eeb.jpg";